if(!customElements.get('collection-display')){
    class CollectionDisplay extends HTMLElement {
        constructor() {
            super();
        }
        
        EventUnSubscriber = undefined
        connectedCallback() {
            this.Initialize()
        }
        disconnectedCallback() {
            this.EventUnSubscriber?.()
        }
        Initialize() {
            this.UseRecursiveFetch = false
            this.SectionID = this.dataset.section
            this.EventID = this.dataset.section
            this.SortBy = this.dataset.sortBy || 'featured'
            this.UrlBase = this.dataset.url
            this.HasNext = this.ParseBoolean(this.dataset.hasNext)
            this.Filters = new Set()
            this.EventUnSubscriber = SubscribeToEvent(`FilterSortEvent`, (eventData) => {
                this.OnEvent(eventData)
            });
        }

        // Handle Incoming Filter and Sort Events
        async OnEvent(eventData) {
            if (eventData.target === this.dataset.section) {
                switch (eventData.type) {
                    case 'FilterAdd':
                        this.AddFilter(eventData.value)
                        await this.FetchFilterSort()
                        this.ApplyResults()
                    break
                    case 'FilterRemove':
                        this.RemoveFilter(eventData.value)
                        await this.FetchFilterSort()
                        this.ApplyResults()
                    break
                    case 'Sort':
                        this.SetSort(eventData.value)
                        await this.FetchFilterSort()
                        this.ApplyResults()
                    break
                    case 'ApplyResults':
                        // this.ApplyResults()
                        theme?.Overlay?.DeActivateOverlay?.()
                    break
                    case 'ClearFilters':
                        this.Filters = new Set()
                        this.querySelector('#GridContainer').innerHTML = ''
                        await this.FetchFilterSort()
                        this.ApplyResults()
                    break
                }
            }
            // console.log(eventData)
        }
        SetSort(Value) {
            this.SortBy = Value
        }
        AddFilter(FilterParam) {
            this.Filters.add(FilterParam)
        }
        RemoveFilter(FilterParam) {
            this.Filters.delete(FilterParam)
        }
        ParseBoolean(str) {
            return String(str).trim().toLowerCase() === "true";
        }
        SetHasNext(dataset) {
            // Takes the DataSet of a Fetched Container and sets this.HasNext to true or false depending on the containers dataset.nextPage value
            this.HasNext = !!dataset.nextPage
        }
        ReturnFinalUrl() {
            let PageParam =''
            if (this.HasNext){
                const NextPage = parseInt(this.dataset.currentPage) + 1
                this.dataset.currentPage = NextPage
                PageParam = `&page=${parseInt(this.dataset.currentPage)}`
            }
            const FilterString = [...this.Filters].join('')

            return `${this.UrlBase}?sort_by=${this.SortBy}${FilterString}${PageParam}&section_id=${this.SectionID}`
        }
        async FetchFilterSort() {
            try {
                this.dataset.currentPage = 1
                this.HasNext = false
                const res = await fetch(this.ReturnFinalUrl())
                if (!res.ok) {
                    // TODO NOTIFICATION ERROR HANDLING
                    console.log(await res.text())
                    throw new Error(`Network response was not ok`);
                } else {
                    const response = await res.text()
                    const NewContainer = new DOMParser().parseFromString(response, 'text/html').querySelector('#GridContainer');
                    const OldContainer = this.querySelector('#GridContainer')
                    if (NewContainer && OldContainer) {
                        this.SetHasNext(NewContainer.dataset)
                        OldContainer.innerHTML = NewContainer.innerHTML
                        this.SendCount(NewContainer.childElementCount)
                    }
                }
            } catch (error) {
                console.log(`FetchFilterSortData Error: ${error.message}`, error )
            }
        }
        async GetNextPage() {
            try {
                const res = await fetch(this.ReturnFinalUrl())
                if (!res.ok) {
                    // TODO NOTIFICATION ERROR HANDLING
                    console.log(await res.text())
                    throw new Error(`Network response was not ok`);
                } else {
                    const response = await res.text()
                    const NewContainer = new DOMParser().parseFromString(response, 'text/html').querySelector('#GridContainer');
                    const OldContainer = this.querySelector('#GridContainer')
                    if (NewContainer && OldContainer) {
                        OldContainer.innerHTML += NewContainer.innerHTML
                        this.SetHasNext(NewContainer.dataset)
                        if (this.UseRecursiveFetch === true) {
                            if (this.HasNext) {
                                await this.GetNextPage()
                            } else {
                                this.ApplyResults();
                                TriggerEvent(`Intersection-${this.EventID}`, {state: 'done'})
                            }
                        } else {
                            this.ApplyResults();
                            TriggerEvent(`Intersection-${this.EventID}`, {state: 'done'})
                        }
                    }
                }
            } catch (error) {
                console.log('FetchNextPage Error:')
            }
        }
        async HandleIntersection(){
            if (this.HasNext) {
                TriggerEvent(`Intersection-${this.EventID}`, {state: 'loading'})
                await this.GetNextPage()
            }
        }

        SendCount(number) {
            const Numbmer = this.Filters.size > 0 ? number : 0
            TriggerEvent('FilterSortCount', {type: 'UpdateCount', target: this.dataset.section, value: Numbmer})
        }

        ApplyResults() {
            InitializeGridCascades?.()
            InitializeAnimationElements?.()
        }
    }
    customElements.define('collection-display', CollectionDisplay);
}